class LocalNewsService {
  static LOCALSTORAGE_KEY = "bruzzlocalnewslocation";

  static getLocations = () => {
    if (window.drupalSettings && window.drupalSettings.municipalities) {
      return window.drupalSettings.municipalities;
    }

    return [];
  };

  static getSavedLocation = () => {
    try {
      const savedLocation = window.localStorage.getItem(
        LocalNewsService.LOCALSTORAGE_KEY
      );
      const locations = LocalNewsService.getLocations();

      return locations.find((location) => location.id === savedLocation);
    } catch (e) {
      console.log(e); // eslint-disable-line no-console
      return "";
    }
  };

  static saveLocation = (location) => {
    try {
      window.localStorage.setItem(
        LocalNewsService.LOCALSTORAGE_KEY,
        location.id
      );
    } catch (error) {
      // in incognito mode this doesn't work, but who cares it's progressive man!
    }
  };
}

export default LocalNewsService;
